var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Suche",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.564,
    height: 18.112,
    viewBox: "0 0 26.564 18.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Eye",
    d: "M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z",
    transform: "translate(0 0)",
    fill: "#dfe2e6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Eye-2",
    "data-name": "Eye",
    d: "M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z",
    transform: "translate(0 0)",
    fill: "#dfe2e6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeInactive);
export default __webpack_public_path__ + "static/media/eye-inactive.872eddde.svg";
export { ForwardRef as ReactComponent };